
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exhibition/[id]",
      function () {
        return require("private-next-pages/exhibition/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exhibition/[id]"])
      });
    }
  